// utils/qrStyles.ts

import { Options } from 'qr-code-styling-ba';

export const getQRStyle = (styleKey: string, image?: string): Options => {
  const baseConfig: Partial<Options> = {
    width: 200,
    height: 200,
    ...(image
      ? {
          image,
          imageOptions: {
            crossOrigin: 'anonymous',
            imageSize: 0.2,
          },
        }
      : {}),
  };

  const styles: Record<string, Partial<Options>> = {
    default: {
      dotsOptions: { type: 'rounded', color: '#000000' },
      backgroundOptions: {
        color: '#ffffff',
        marginColor: "#ffffff",
        outlineColor: "#000000",
        innerLineColor: "#000000",
        outlineWidth: 2,
        innerLineWidth: 1,
        marginTextFont: 'Arial, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#000000',
      },
    },

    blackMarginWhiteBackBlackDots: { 
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#000000' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#000000' },
      cornersDotOptions: { type: 'dot', color: '#000000' },
      backgroundOptions: {
        color: '#ffffff',
        marginColor: "#000000",
        outlineColor: "#555555",
        innerLineColor: "#555555",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Arial, sans-serif',
        marginTextSize: 9,
        marginTextColor: '#ffffff',
        chamfer: 5
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
  
    whiteMarginBlackBackWhiteDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#ffffff' },
      cornersSquareOptions: { type: 'square', color: '#ffffff' },
      cornersDotOptions: { type: 'dot', color: '#ffffff' },
      backgroundOptions: {
        color: '#000000',
        marginColor: "#ffffff",
        outlineColor: "#888888",
        innerLineColor: "#888888",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Courier New, monospace',
        marginTextSize: 9,
        marginTextColor: '#000000',
        chamfer: 5
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
  
    blueMarginLightGrayBackNavyDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'rounded', color: '#001f3f' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#001f3f' },
      cornersDotOptions: { type: 'dot', color: '#001f3f' },
      backgroundOptions: {
        color: '#f0f0f0',
        marginColor: "#0074D9",
        outlineColor: "#0074D9",
        innerLineColor: "#0074D9",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Verdana, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#ffffff',
        chamfer: 3
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
  
    greenMarginCreamBackDarkGreenDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'classy', color: '#006400' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#006400' },
      cornersDotOptions: { type: 'dot', color: '#006400' },
      backgroundOptions: {
        color: '#fffdd0',
        marginColor: "#228B22",
        outlineColor: "#228B22",
        innerLineColor: "#228B22",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Georgia, serif',
        marginTextSize: 9,
        marginTextColor: '#ffffff',
        chamfer: 4
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
  
    redMarginWhiteBackDarkRedEyes: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#8B0000' },
      cornersSquareOptions: { type: 'dot', color: '#8B0000' },
      cornersDotOptions: { type: 'square', color: '#8B0000' },
      backgroundOptions: {
        color: '#ffffff',
        marginColor: "#FF4136",
        outlineColor: "#FF4136",
        innerLineColor: "#FF4136",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Impact, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#ffffff',
        chamfer: 6
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
  
    neonGreenMarginDarkGrayBackLimeDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'extra-rounded', color: '#32CD32' },
      cornersSquareOptions: { type: 'square', color: '#32CD32' },
      cornersDotOptions: { type: 'dot', color: '#32CD32' },
      backgroundOptions: {
        color: '#2f2f2f',
        marginColor: "#39FF14",
        outlineColor: "#39FF14",
        innerLineColor: "#39FF14",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Roboto Mono, monospace',
        marginTextSize: 9,
        marginTextColor: '#000000',
        chamfer: 2
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
    techBlue: {
      dotsOptions: { type: 'square', color: '#1e40af' },
      cornersSquareOptions: { type: 'square', color: '#1e3a8a' },
      cornersDotOptions: { type: 'square', color: '#1e3a8a' },
      backgroundOptions: { color: '#f9fafb' },
    },
    blackDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#000000' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#000000' },
      cornersDotOptions: { type: 'dot', color: '#000000' },
      backgroundOptions: {
        color: '#ffffff', //4C661B
        marginColor: "#FFFFFF",
        outlineColor: "#000000",
        innerLineColor: "#000000",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Arial, sans-serif',
        marginTextSize: 9,
        marginTextColor: '#000000',
        chamfer: 5
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
    swm: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#5D3A62' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#5D3A62' },
      cornersDotOptions: { type: 'dot', color: '#5D3A62' },
      backgroundOptions: {
        color: '#ffffff',
        marginColor: "#5D3A62",
        outlineColor: "#333333",
        innerLineColor: "#333333",
        outlineWidth: 0,
        innerLineWidth: 0,
        marginTextFont: 'Arial, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#ffffff',
        chamfer: 5
      },
      shape: "hexagon",
      margin: 15,
      type: "svg",
    },
    greenDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#ffffff' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#ffffff' },
      cornersDotOptions: { type: 'dot', color: '#ffffff' },
      backgroundOptions: {
        color: '#8C9763', //4C661B 8C9763
        marginColor: "#8C9763",
        outlineColor: "#333333",
        innerLineColor: "#333333",
        outlineWidth: 1,
        innerLineWidth: 1,
        marginTextFont: 'Impact, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#222222',
        chamfer: 5
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
    magentaDots: {
      imageOptions: { crossOrigin: 'anonymous', imageSize: 0.7, margin: 0.5 },
      dotsOptions: { type: 'dots', color: '#370d73' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#370d73' },
      cornersDotOptions: { type: 'dot', color: '#370d73' },
      backgroundOptions: {
        color: '#ffffff',
        marginColor: "#8C9763",
        outlineColor: "#333333",
        innerLineColor: "#333333",
        outlineWidth: 2,
        innerLineWidth: 1,
        marginTextFont: 'Arial, sans-serif',
        marginTextSize: 10,
        marginTextColor: '#222222',
      },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
    orangeWave: {
      dotsOptions: { type: 'rounded', color: '#f97316' },
      cornersSquareOptions: { type: 'dot', color: '#c2410c' },
      cornersDotOptions: { type: 'dot', color: '#c2410c' },
      backgroundOptions: { color: '#fff7ed' },
      shape: "hexagon",
    },
    oceanTeal: {
      dotsOptions: { type: 'rounded', color: '#0d9488' },
      cornersSquareOptions: { type: 'square', color: '#115e59' },
      cornersDotOptions: { type: 'dot', color: '#115e59' },
      backgroundOptions: { color: '#ecfdf5' },
      shape: "hexagon",
    },
    sunsetPink: {
      dotsOptions: { type: 'dots', color: '#f472b6' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#be185d' },
      cornersDotOptions: { type: 'dot', color: '#be185d' },
      backgroundOptions: { color: '#fdf2f8' },
      shape: "hexagon",
    },
    cyberPurple: {
      dotsOptions: { type: 'dots', color: '#7c3aed' },
      cornersSquareOptions: { type: 'square', color: '#581c87' },
      cornersDotOptions: { type: 'dot', color: '#581c87' },
      backgroundOptions: { color: '#f5f3ff' },
      shape: "hexagon",
    },
    fireRed: {
      dotsOptions: { type: 'square', color: '#dc2626' },
      cornersSquareOptions: { type: 'square', color: '#7f1d1d' },
      cornersDotOptions: { type: 'dot', color: '#7f1d1d' },
      backgroundOptions: { color: '#fef2f2' },
      shape: "hexagon",
      margin: 20,
      type: "svg",
    },
    lemonYellow: {
      dotsOptions: { type: 'dots', color: '#facc15' },
      cornersSquareOptions: { type: 'extra-rounded', color: '#a16207' },
      cornersDotOptions: { type: 'dot', color: '#a16207' },
      backgroundOptions: { color: '#fefce8' },
    },
    slateGrey: {
      dotsOptions: { type: 'rounded', color: '#64748b' },
      cornersSquareOptions: { type: 'square', color: '#334155' },
      cornersDotOptions: { type: 'square', color: '#334155' },
      backgroundOptions: { color: '#f8fafc' },
    },
  };

  return {
    ...(styles[styleKey] || styles.default),
    ...baseConfig,
  } as Options;
};

